import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'OR',
  category: FunctionCategory.LOGIC,
  description:
    'Returns true if any of the values in a single column OR any of the values across each row for multiple columns are logically true, and false otherwise. Single values are treated as columns containing just that value.',
  shortDescription: 'Logical OR operator',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'Either a column or value.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'Additional columns or values.',
} satisfies AnalysisFunction;
